import cache from 'helpers/rxjs-operators/cache';
import IUser from 'interfaces/models/core/user/user';
import IUserRole from 'interfaces/models/core/user/userRole';
import { IPaginationParams, IPaginationResponse } from 'interfaces/pagination';
import { Observable } from 'rxjs';

import apiService, { ApiService } from './api';

export class UserService {
  private baseServiceUrl = '/core/user';

  constructor(private apiService: ApiService) {}

  public list(params: IPaginationParams): Observable<IPaginationResponse<IUser>> {
    return this.apiService.get('/core/list-users', params);
  }

  public current(): Observable<IUser> {
    return this.apiService.get('/core/auth/profile');
  }

  public roles(refresh: boolean = false): Observable<IUserRole[]> {
    return this.apiService.get(this.baseServiceUrl + '/roles').pipe(cache('user-service-roles', { refresh }));
  }

  public save(model: Partial<IUser>): Observable<IUser> {
    return this.apiService.post(this.baseServiceUrl + '', model);
  }

  public delete(id: number): Observable<void> {
    return this.apiService.delete(`${this.baseServiceUrl}/${id}`);
  }
}

const userService = new UserService(apiService);
export default userService;
